import {ServiceTypeEntity} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {BaseEntitySelect, BaseEntitySelectProps} from "../base-entity-select";

export type BaseServiceTypeSelectProps = Omit<
  BaseEntitySelectProps<ServiceTypeEntity>,
  'nameMapper'
> & {
  useAbbreviation?: boolean;
};

export const BaseServiceTypeSelect = (props: BaseServiceTypeSelectProps) => {
  const {useAbbreviation = true, ...rest} = props;

  const nameMapper = useCallback(
    (e: ServiceTypeEntity) => {
      let name: string
      if (useAbbreviation) {
        name = e.abbr ?? e.name;
      } else {
        name = e.name;
      }

      if (typeof e.operatorIsPickup !== 'undefined' && !e.operatorIsPickup) {
        name += " (D)"
      } else {
        name += " (P)"
      }

      return name
    },
    [useAbbreviation]
  );

  return <BaseEntitySelect {...rest} nameMapper={nameMapper}/>;
}
